export enum RoleLevel {
    applicationAdmin = 1,
    laboratoryAdmin,
    tester,
    developer,
    leadUser,
    user
}
